import { useEffect, useState } from 'react';
import { useParams, NavLink, Route, Routes } from 'react-router-dom';
import css from './CustomerDetails.module.css';

import * as customerServices from '../../../../services/customerServices';
import ModalForm from '../../_common/ModalForm';
import AddCustomer from './AddCustomer';
import CustomerGeneral from './CustomerGeneral'; // create similar to CDGeneral
// import CustomerContracts from './CustomerContracts'; // optional tab content
// import CustomerNotes from './CustomerNotes'; // optional tab content
import Tabs from '../../../00_app/Tabs';
import CustomerContracts from './CustomerContracts';

function CustomerDetails() {
    const { customerId } = useParams();
    const [customerDetails, setCustomerDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [message, setMessage] = useState('');
    const [render, setRender] = useState(0);

    useEffect(() => {
        customerServices
            .getById(customerId)
            .then((result) => {
                setCustomerDetails(result.data[0]);
                // console.log(result.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [customerId, render]);

    const toggleModal = () => setShowModal(!showModal);

    //#######################Check if this code is still needed
    const onUpdate = (e) => {
        // e.preventDefault();
        toggleModal();
        // setRender((prev) => prev + 1);
    };
    const onClose = (e) => {
        // e.preventDefault();
        toggleModal();
    };

    //#################################Up to here

    return (
        <div>
            <h1 className={css.h1}>{customerDetails?.customerName}</h1>

            <CustomerGeneral data={customerDetails} toggleModal={toggleModal} />

            <Tabs
                tabs={[
                    { to: `/customer/details/${customerId}/contracts`, title: 'Contracts' },
                    { to: `/customer/details/${customerId}/notes`, title: 'Notes' },
                ]}
            />

            <Routes>
                <Route path="contracts" element={<CustomerContracts customerId={customerId} />} />
                {/* <Route path="notes" element={<CustomerNotes customerId={customerId} />} /> */}
            </Routes>

            <ModalForm showModal={showModal}>
                <AddCustomer data={customerDetails} onAdd={onUpdate} toggleModal={toggleModal} func="edit" onClose={onClose} />
            </ModalForm>
            <p style={{ color: 'orange', textAlign: 'right' }}>UX in progress ...</p>
        </div>
    );
}

export default CustomerDetails;
